import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { getSorting } from 'utils/general';
import {
  AdminTermsFilters,
  TermsVersion,
  TermsVersionDetails,
} from './admin-terms.types';

interface TermsListResponse {
  count: number;
  page: number;
  pageSize: number;
  data: TermsVersion[];
}

interface GetTerms {
  filters: Partial<AdminTermsFilters>;
}

interface GetTerm {
  termId: string;
}

interface CreateTerm {
  content: string;
}

export const loaders = {
  getTerms: ({ filters }: GetTerms) => {
    return api<TermsListResponse>({
      url: Endpoints.melpAdmin.terms.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
        ...getSorting(filters.sort),
      },
    });
  },
  getTerm: ({ termId }: GetTerm) => {
    return api<TermsVersionDetails>({
      url: Endpoints.melpAdmin.terms.byId.replace(':termId', termId),
    });
  },
  createTerm: ({ content }: CreateTerm) => {
    return api<TermsVersionDetails>({
      url: Endpoints.melpAdmin.terms.root,
      method: 'post',
      data: { content },
    });
  },
};
